<template>
    <vx-card title="Internal Order">
        <div class="flex vx-input-group">
            <vs-tabs :value="activeTab">
                <vs-tab label="Draft">
                    <tab-draft></tab-draft>
                </vs-tab>
                <vs-tab label="Waiting">
                    <tab-waiting></tab-waiting>
                </vs-tab>
                <vs-tab label="Inquiry">
                    <tab-inquiry></tab-inquiry>
                </vs-tab>
                <!-- setelah di approve langsung ke release -->
                <vs-tab label="Released">
                    <tab-released></tab-released>
                </vs-tab>
                <vs-tab label="Rejected">
                    <tab-rejected></tab-rejected>
                </vs-tab>
                <vs-tab label="Canceled">
                    <tab-canceled></tab-canceled>
                </vs-tab>
                <!-- <vs-tab label="Amended">
                    <tab-amended></tab-amended>
                </vs-tab> -->
                <vs-tab label="Closed">
                    <tab-closed></tab-closed>
                </vs-tab>
                <!-- <vs-tab label="Log Import">
                    <tab-log></tab-log>
                </vs-tab> -->
            </vs-tabs>
        </div>
    </vx-card>
</template>
<script>
import TabDraft from "./TabDraft.vue"; // 0
import TabWaiting from "./TabWaiting.vue"; // 1
import TabInquiry from "./TabInquiry.vue"; // 2
import TabReleased from "./TabReleased.vue"; // 3
import TabRejected from "./TabRejected.vue"; // 4
import TabCanceled from "./TabCanceled.vue"; // 5
// import TabAmended from "./TabAmended.vue";
import TabClosed from "./TabClosed.vue"; // 6
// import TabLog from "./TabLogImport.vue";
export default {
    components: {
        TabCanceled,
        TabClosed,
        TabDraft,
        TabRejected,
        TabReleased,
        TabWaiting,
        TabInquiry,
    },
    data() {
        return {
            activeTab: sessionStorage.getItem('activeTabPO') ? sessionStorage.getItem('activeTabPO') : "0",
        }
    },
    methods: {},
    mounted() {
        console.log("index ===== ", sessionStorage.getItem('activeTabPO'))
    }
}
</script>
